module.exports = __webpack_public_path__ + "static/media/dale.d91a39b0.png";